import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Row, Col, ListHeader, CreditApplyForm, Button, Paper } from 'components';
import { jsx as ___EmotionJSX } from "@emotion/react";

var CreditCalculator = function CreditCalculator() {
  var history = useHistory();

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      credit = _useState2[0],
      setCredit = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      creditFormData = _useState4[0],
      setCreditFormData = _useState4[1];

  var handleCreditChange = function handleCreditChange(creditData, formData) {
    setCredit(creditData);
    if (formData) setCreditFormData(formData);
  };

  var handleContinueToApply = function handleContinueToApply() {
    history.push('/credits/new', {
      creditFormData: creditFormData
    });
  };

  return ___EmotionJSX(Row, {
    backgroundColor: "white",
    horizontalGap: 16,
    container: true
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(ListHeader, {
    title: "\u041A\u0440\u0435\u0434\u0438\u0442\u0435\u043D \u043A\u0430\u043B\u043A\u0443\u043B\u0430\u0442\u043E\u0440"
  })), ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(CreditApplyForm, {
    credit: credit,
    onCreditChange: handleCreditChange,
    isCalculator: true
  }), credit && ___EmotionJSX(Paper, {
    margin: "0 0 2em 0"
  }, ___EmotionJSX(Row, null, ___EmotionJSX(Col, {
    displayFlex: true,
    md: 12,
    justify: "flex-end"
  }, ___EmotionJSX(Button, {
    type: "primary",
    onClick: handleContinueToApply
  }, "\u041F\u0440\u043E\u0434\u044A\u043B\u0436\u0438 \u043A\u044A\u043C \u043A\u0430\u043D\u0434\u0438\u0434\u0430\u0442\u0441\u0442\u0432\u0430\u043D\u0435"))))));
};

CreditCalculator.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object
};
export default CreditCalculator;